export function saveAccessToken(token: string) {
  sessionStorage.setItem("access_token", token)
}

export function getAccessToken() {
  return sessionStorage.getItem("access_token")
}

export function destroyAccessToken() {
  sessionStorage.removeItem("access_token")
}

export const saveRefreshToken = (token: string) => sessionStorage.setItem("refresh_token", token)

export const getRefreshToken = () => sessionStorage.getItem("refresh_token")

export const removeRefreshToken = () => sessionStorage.removeItem("refresh_token")
